import {ApolloLink, Observable} from '@apollo/client';

export default generateSubscription =>
  new ApolloLink(
    (operation, forward) =>
      new Observable(observer => {
        const subscription = forward(operation).subscribe(
          generateSubscription({operation, forward, observer})
        );

        return () => subscription.unsubscribe();
      })
  );
